export LightenColor from './LightenColor'
export RemoveAcento from './removeAcento'
export Dates from './dates'
export String from './string'
export isTouchCapable from './isTouchCapable'
export {getStatusAtendimento, getStatusRowAtendimento} from './getStatusAtendimento'
export getTipoImpressao from './getTipoImpressao'